var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"color":"#9d9d9d","text-align":"left","padding":"30px 0"}},[_c('el-row',[_c('el-col',{attrs:{"span":18,"offset":3}},[_c('div',{staticStyle:{"line-height":"2"},attrs:{"span":14,"xs":{span:24}}},[_c('span',{staticStyle:{"font-size":"18px"}},[_vm._v("系统管理...")])])])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }